// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2QZ-E","checkboxCol":"Table_checkboxCol__3czPn","emailCol":"Table_emailCol__PwGIZ","actionCol":"Table_actionCol__37Ir-"};